<template>
  <div
    v-if="logo && logo.svg"
    class="relative overflow-hidden rounded shadow-lg"
    @click="$emit('click', $event)"
    @keyup.enter="$emit('click', $event)"
  >
    <Watermark v-if="showWatermark" :background="background" />

    <div class="logo-preview w-full" v-html="logo.svg"></div>
  </div>
</template>

<script>
import { getPaletteFromLogo } from '@/lib/helpers/editor'
import Watermark from '@/components/Watermark'
import { getPaletteHexValue } from '@/lib/helpers/logos'

export default {
  components: { Watermark },

  props: {
    showWatermark: { type: Boolean, default: false },
    logo: { type: Object, required: true },
  },

  computed: {
    palette() {
      return getPaletteFromLogo(this.logo) || {}
    },

    background() {
      return getPaletteHexValue(this.palette.background)
    },
  },
}
</script>

<style lang="scss">
.logo-preview svg {
  @apply w-full h-auto;
}
</style>
